import React, { FC, createElement, useEffect, useState } from 'react';
import { ReactComponent as TitleIcon } from 'assets/icons/update-surge-modal-icon.svg';
import SurgeTabs from '../surge-tabs';
import PolygonSurgeApplyNow from './polygon-surge-apply-now';
import PolygonSurgeSchedule from './polygon-surge-schedule';
import PolygonSurgeHistory from './polygon-surge-history';
import EditPolygonSurge from '../edit-polygon';
import { BaseModal, Button } from '@cokitchen/cokitchen-components';
import { EditSurgeTabType, PolygonSurgeTabProps, SurgeTabType } from '../surge-tabs/types';
import { ActiveGeneralSurgeType } from 'models/surge.model';
import { CoKitchenPolygons } from 'models/cokitchen.model';
import { PolygonsTab } from 'components/base/polygons-tab';

type PolygonSurgeModalProps = {
  show: boolean;
  onClose: () => void;
  activeSurge: ActiveGeneralSurgeType;
  setActiveSurge: (arg1: any) => void;
};

const PolygonSurgeModal: FC<PolygonSurgeModalProps> = ({
  show,
  onClose,
  activeSurge,
  setActiveSurge
}) => {
  const [active, setActive] = useState<SurgeTabType>('Apply Now');
  const [trigger, setTrigger] = useState('' as EditSurgeTabType);
  const [loading, setLoading] = useState(false);
  const [step, setStep] = useState(1);
  const [activePolygon, setActivePolygon] = useState({} as CoKitchenPolygons);

  useEffect(() => {
    setTrigger('' as EditSurgeTabType);
    setActive('Apply Now');
    setStep(1);
  }, [show]);

  const onConfirm = () => {
    if (step === 3) {
      setTrigger('Edit');
    } else {
      setTrigger(active);
    }
  };

  const tabList: SurgeTabType[] = ['Apply Now', 'Schedule', 'History'];
  const tabComponents: Record<SurgeTabType, any> = {
    'Apply Now': PolygonSurgeApplyNow,
    Schedule: PolygonSurgeSchedule,
    History: PolygonSurgeHistory
    // Fleets: PolygonFleets
  };

  const onBackModal = () => {
    setStep((prev) => prev - 1);
  };
  const hideConfirmButton = () => {
    return active === 'History' || step === 2;
  };

  return (
    <BaseModal
      isOpen={show}
      title={step === 1 ? 'Manage Polygon Surge' : 'Edit Schedule Surge'}
      description={
        step === 1
          ? 'Applying surge multiplies the delivery price by the appropriate value.'
          : undefined
      }
      titleIcon={<TitleIcon />}
      titleIconColor='info'
      onRequestClose={onClose}
      hasBackButton={step !== 1}
      onBackButton={onBackModal}
      titleCta={
        step === 1 ? (
          <p
            onClick={() => {
              setStep(step + 1);
            }}
            className='text-[#E60A2B] underline text-sm cursor-pointer'>
            Edit Scheduled surge
          </p>
        ) : undefined
      }
      footer={
        hideConfirmButton() ? undefined : (
          <Button small color='primary' variant='block' loading={loading} onClick={onConfirm}>
            Confirm
          </Button>
        )
      }>
      {step === 1 ? (
        <div className='lg:min-h-[300px]'>
          <SurgeTabs list={tabList} active={active} setActive={setActive} />

          <div className='mt-3'>
            <PolygonsTab
              activePolygon={activePolygon}
              setActivePolygon={setActivePolygon}
              smallText
              isModalView
            />
          </div>

          {createElement(tabComponents[active] as FC<PolygonSurgeTabProps>, {
            cokitchen_polygon_id: activePolygon?.id,
            confirm: trigger,
            setLoading: setLoading,
            onClose: onClose,
            activeSurge: activeSurge,
            setActiveSurge: setActiveSurge
          })}
        </div>
      ) : (
        <EditPolygonSurge
          confirm={trigger}
          setLoading={setLoading}
          onClose={onClose}
          cokitchen_polygon_id={activePolygon.id}
          setStep={setStep}
          step={step}
        />
      )}
    </BaseModal>
  );
};

export default PolygonSurgeModal;
